module.exports = __webpack_public_path__ + "media/138.4bda8ce9.wav";